import React, { useLayoutEffect, useRef } from "react";

function Footer() {
  const footerRef = useRef(null);

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;
    const updateFooterHeight = () => {
      if (!footerRef.current) return;
      document.documentElement.style.setProperty(
        "--auth-footer-height",
        `${footerRef.current.offsetHeight}px`,
      );
    };

    updateFooterHeight();
    window.addEventListener("resize", updateFooterHeight);
    return () => window.removeEventListener("resize", updateFooterHeight);
  }, []);

  return (
    <footer
      ref={footerRef}
      className="z-10 w-full bg-slate-900 text-slate-300 py-0"
    >
      {/* <footer className="w-full bg-slate-900 text-slate-300 py-3"> */}
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-6">
          <div>
            <h4 className="font-semibold text-white mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>About</li>
              <li>Careers</li>
              <li>Press</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-3">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>Privacy</li>
              <li>Terms</li>
              <li>Cookies</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-3">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>Help Center</li>
              <li>Safety</li>
              <li>Community</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-3">Download</h4>
            <ul className="space-y-2 text-sm">
              <li>iOS App</li>
              <li>Android App</li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className="w-full border-t border-slate-700 pt-3 pb-2">
        <div className="text-center text-sm text-slate-400">
          <span>© 2026 Vibely. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}

export default React.memo(Footer);
